import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
// Removed material-ui-popup-state; using controlled MUI Menu
import VisibilityIcon from "@mui/icons-material/Visibility";
import SendIcon from "@mui/icons-material/Send";
import moment from "moment";
import { toastMessage } from "utils/toastMessage";
import { useSelector } from "react-redux";
import {
  approveProspect,
  rejectProspect,
  sendForApproval,
} from "_controllers/officer";
import CustomerProspectView from "./CustomerProspectView";

const CustomerProspectTable = ({
  data,
  header,
  setReload,
  remarkAction,
  openPreview,
  setOpenPreview,
  setProspectInfo,
  prospectInfo,
  openTimeline,
  setOpenTimeline,
  setProspectId1,
}) => {
  let user = useSelector((state) => state.user);
  console.log("datacuso", data, header);

  const [userData, setUserData] = useState();
  const [open, setOpen] = useState(false);

  const sendToActyv = async (rowData) => {
    let data = await sendForApproval({ id: rowData._id, type: rowData.type });
    if (data?.status === "failure") {
      toastMessage(data?.message, data?.status);
    } else if (data?.status === "success") {
      setReload(rowData?._id);
      toastMessage("Prospect sent to Actyv", "success");
    }
  };
  const rejectAction = async (prospect) => {
    await rejectProspect(prospect.prospect_id, prospect.prospectType)
      .then((d) => {
        console.log("data", d);
        setReload(prospect.prospect_id);
        toastMessage(d?.data?.message, "success");
      })
      .catch((err) => {
        console.log("err", err);
        // setLoading(false);
        toastMessage("error fetching data", "error");
      });
  };
  const approveAction = async (prospect) => {
    await approveProspect(prospect.prospect_id, prospect.prospectType)
      .then((d) => {
        console.log("data", d);
        setReload(prospect.prospect_id);
        toastMessage(d?.data?.message, "success");
      })
      .catch((err) => {
        console.log("err", err);
        // setLoading(false);
        toastMessage("error fetching data", "error");
      });
  };
  const handleButtonClick2 = (rowData) => {
    // Perform the action for Button 2
    console.log("Button 2 clicked for row data:", rowData);
    toastMessage("Feature Under Development", "success");
  };

  const handleButtonClick3 = (rowData) => {
    // Perform the action for Button 3
    console.log("Button 3 clicked for row data:", rowData);
    toastMessage("Feature Under Development", "success");
  };

  const handleCloseCustomer = () => {
    setOpen(false);
  };

  // Menu state for actions per table (single open at a time)
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuProspect, setMenuProspect] = useState(null);
  const isMenuOpen = Boolean(menuAnchorEl);
  const openMenu = (event, prospect) => {
    setMenuAnchorEl(event.currentTarget);
    setMenuProspect(prospect);
  };
  const closeMenu = () => {
    setMenuAnchorEl(null);
    setMenuProspect(null);
  };

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          height: "100%",
          overflow: "auto",
        }}
      >
        <Table stickyHeader>
          {header && header.length > 0 ? (
            <TableHead>
              <TableRow>
                {header.map((item, idx) => (
                  <TableCell
                    align="left"
                    sx={{ fontWeight: "bolder" }}
                    key={idx}
                  >
                    {item.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
          ) : null}

          <TableBody>
            {data && data?.length > 0 ? (
              data?.map((d) => (
                <TableRow key={d?._id}>
                  <TableCell align="left">
                    {d?.createdBy?.SAP_ID ?? "-"}
                  </TableCell>
                  <TableCell align="left">
                    {d?.businessDetails?.firmName ?? "-"}
                  </TableCell>
                  <TableCell align="left">
                    {d?.businessDetails?.businessEmail ?? "-"}
                  </TableCell>
                  <TableCell align="left">
                    {d?.businessDetails?.transportContactNumber ?? "-"}
                  </TableCell>
                  {/* <TableCell align="center">
                    {d?.customerDetails?.name ?? "-"}
                  </TableCell> */}
                  {/* <TableCell align="center">
                    {d?.customerDetails?.dateOfBirth
                      ? moment
                          .utc(d?.customerDetails?.dateOfBirth)
                          .format("YYYY-MM-DD")
                      : "-"}
                  </TableCell> */}
                  <TableCell align="left">
                    {d?.customerDetails?.phoneNumber ?? "-"}
                  </TableCell>
                  <TableCell align="left">
                    <VisibilityIcon
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setOpen(true);
                        setUserData(d);
                      }}
                    />
                  </TableCell>
                  <TableCell align="left">
                    <Button
                      variant="contained"
                      onClick={(e) => openMenu(e, d?.prosStatus)}
                      disabled={
                        !d?.prosStatus
                          ? true
                          : d?.prosStatus?.status?.includes("Pending")
                          ? false
                          : user?.user?.role == "ADMIN" &&
                            d?.prosStatus?.status == "Pending_HO"
                          ? false
                          : true
                      }
                    >
                      {d?.prosStatus ? d?.prosStatus?.status : "N/A"}
                    </Button>
                    <Menu anchorEl={menuAnchorEl} open={isMenuOpen} onClose={closeMenu}>
                      <MenuItem
                        onClick={() => {
                          if (menuProspect) approveAction(menuProspect);
                          closeMenu();
                        }}
                      >
                        Approve
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          if (menuProspect) rejectAction(menuProspect);
                          closeMenu();
                        }}
                      >
                        Reject
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          if (menuProspect) remarkAction({ close: closeMenu }, menuProspect);
                          closeMenu();
                        }}
                      >
                        Remark
                      </MenuItem>
                    </Menu>
                  </TableCell>
                  {/* {user.user.role == "ADMIN" ? */}
                  <TableCell align="center">
                    <Button
                      onClick={() => sendToActyv(d)}
                      variant="contained"
                      endIcon={<SendIcon />}
                      style={{ fontSize: "12px" }}
                      disabled={
                        d?.detailSendToActyv
                          ? true
                          : d?.prosStatus?.status === "Rejected"
                          ? true
                          : false
                      }
                    >
                      approval
                    </Button>
                  </TableCell>
                  {/* : ""} */}
                  <TableCell align="left">
                    <Button
                      variant="contained"
                      disabled={
                        d?.documentLinks
                          ? d?.documentLinks.length > 0
                            ? false
                            : true
                          : true
                      }
                      onClick={() => {
                        setOpenPreview(true);
                        setProspectInfo(d);
                      }}
                    >
                      Preview
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      onClick={() => handleButtonClick3(d)}
                      variant="contained"
                      disabled={true}
                      endIcon={<SendIcon />}
                      style={{ fontSize: "12px" }}
                    >
                      send
                    </Button>
                  </TableCell>
                  <TableCell align="left">
                    <IconButton
                      size="large"
                      color="primary"
                      onClick={() => {
                        setOpenTimeline(true);
                        setProspectId1(d?._id);
                      }}
                    >
                      <RemoveRedEyeIcon fontSize="inherit" />
                    </IconButton>
                  </TableCell>

                  {/* <TableCell align="center">
                    <Button
                      onClick={() => handleButtonClick2(d)}
                      variant="contained"
                    >
                      status
                    </Button>
                  </TableCell> */}
                </TableRow>
              ))
            ) : (
              <Box sx={{ textAlign: "left", pt: 1 }}>
                <Typography variant="h6" sx={{ p: 1 }}>
                  No Data.
                </Typography>
              </Box>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {open ? (
        <CustomerProspectView
          handleCloseCustomer={handleCloseCustomer}
          data={userData}
          remarkAction={remarkAction}
          setReload={setReload}
        />
      ) : null}
    </>
  );
};

export default CustomerProspectTable;
